import { render, staticRenderFns } from "./chongzhi.vue?vue&type=template&id=869e1b02&scoped=true"
import script from "./chongzhi.vue?vue&type=script&lang=js"
export * from "./chongzhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e1b02",
  null
  
)

export default component.exports